import { AppKit } from "@reown/appkit";
import { bitMillionsAbi, bitMillionsAddress } from "../generated";
import { base, baseSepolia } from "wagmi/chains";
import { multicall3Abi } from "viem";

export const IS_MAINNET = false; // window.location.hostname === "bitmillions.app";
export const CHAIN = IS_MAINNET ? base : baseSepolia;

export let isMiniApp: boolean = false;
export const setIsMiniApp = (value: boolean) => {
  isMiniApp = value;
};

export let appKit: AppKit;
export const setAppKit = (value: AppKit) => {
  appKit = value;
};

export const CURRENCY = "USDC";
export const CURRENCY_SYMBOL = "$";
export const USDC_DECIMALS = 6;

export const TICKETS_BOUGHT_IN_DISPLAY = 2;
export const TICKETS_BOUGHT_IN_DRAW_DIALOG = 5;
export const TICKETS_BOUGHT_2_COLUMNS_THRESHOLD = 5;
export const TICKETS_BOUGHT_3_COLUMNS_THRESHOLD = 8;

export const ANIMATION_DELAY_MULTIPLIER = 100;
export const TICKET_CARD_ERROR_PULSING_TIME_MS = 1000;

export const MAXIMUM_WALLET_ADDRESS_LENGTH = 15;

export const MAXIMUM_INSTITUTION_LENGTH = 20;
export const INSTITUTIONS_PER_COLUMN = 8;

export const CHARITY_GOAL_FRACTION = 0.4;

export const LAST_PREVIOUS_DRAW_PROMPTED_KEY = "last_previous_draw_prompted";
export const SECONDS_PER_SLOT_ANIMATION = 1;

export const WIN_RATIO_SPREAD = 1000;

export const STATS_GRID_COLUMN_NUMBER = 4;

export const HOVER_DEBOUNCE_TIME_MS = 250;

export const LUCKY_DIP_LONG_PRESS_MS = 800;

export const DRAWS_IN_HOME = 6;
export const DRAWS_IN_PAGE = 24;
export const DRAWS_ANIMATION_TIME = 500;
export const DRAWS_ANIMATION_TIME_COMPENSATION = 250;

export const contractUrl = `${CHAIN.blockExplorers.default.url}/address/${bitMillionsAddress[CHAIN.id]}`;
export const docsUrl = "https://docs.bitmillions.app"
export const frontendUrl = "https://github.com/Bit-Millions/bitmillions-react";

export const bitMillionsContract = {
  abi: bitMillionsAbi,
  address: bitMillionsAddress[CHAIN.id],
};

export const multicall3Contract = {
  abi: multicall3Abi,
  address: CHAIN.contracts.multicall3.address,
};

interface IndexerOptions {
  playerAddress?: string;
  page?: number;
  count?: number;
  noPlayer: boolean;
  noDraws: boolean;
  noStatistics: boolean;
  noCharities: boolean;
  playedFilter: boolean;
  benefitedFilter: boolean;
}

export const SUBGRAPH_ENDPOINT = "/api/subgraph";
export const NEYNAR_ENDPOINT = "/api/neynar";

export const getIndexerQuery = (options: IndexerOptions): string => `
query MyQuery {
  ${
    (options.noPlayer ?? false)
      ? ""
      : `player(id: "${options.playerAddress}") {
    playerAddress
    ticketsBought
    prizesWon
    drawsEntered
    winningTickets
    jackpotsWon
    highestPrizeWon
  }`
  }
  ${
    (options.noStatistics ?? false)
      ? ""
      : `mainNumberStatistics_collection {
    mainNumber
    lastDrawNumber
    count
  }`
  }
  ${
    (options.noStatistics ?? false)
      ? ""
      : `luckyStarStatistics_collection {
    luckyStar
    lastDrawNumber
    count
  }`
  }
  ${
    (options.noStatistics ?? false)
      ? ""
      : `lotteries {
    proceeds_donations
    proceeds_prizes
    playersEntered
    jackpotsWon
    highestPrizeWon
    highestJackpot
    ticketsBought
    winningTickets
    prizesWon
  }`
  }
  ${
    (options.noCharities ?? false)
      ? ""
      : `charities(where: {active: true}, orderBy: donationsReceived) {
    charityAddress
    donationsReceived
    drawsInvolved
    highestDonationReceived
    name
    website
  }`
  }
  ${
    (options.noDraws ?? false)
      ? ""
      : `draws(
      skip: ${Number(1 + (options.page ?? 0) * DRAWS_IN_PAGE).toString()},
      first: ${Number(options.count ?? 0).toString()},
      orderBy: drawNumber,
      orderDirection: desc,
      where: {
        ${options.playedFilter ? `entries_: {playerAddress: "${options.playerAddress}"}` : ""}${options.benefitedFilter ? "," : ""}
        ${options.benefitedFilter ? `charity: "${options.playerAddress}"` : ""}
      }
    ) {
    charity {
      charityAddress
      donationsReceived
      drawsInvolved
      highestDonationReceived
      name
      website
    }
    drawConfig_jackpotTier_luckyStars
    drawConfig_jackpotTier_mainNumbers
    drawConfig_pools_luckyStars
    drawConfig_pools_mainNumbers
    drawConfig_proceedsAllocation_donations
    drawConfig_proceedsAllocation_prizes
    drawConfig_proceedsAllocation_royalties
    drawConfig_ticketBuyLimit
    drawConfig_ticketPrice
    drawConfig_ticketTotalLimit
    drawConfig_tierAllocations {
      tier_luckyStar
      tier_mainNumber
      cut
    }
    drawNumber
    ${
      options.playerAddress != undefined
        ? `entries(where: {playerAddress: "${options.playerAddress}"}) {
      ticketsBought
      winningTickets
      tickets {
        luckyStars
        mainNumbers
      }
      playerAddress
    }`
        : ""
    }
    jackpot
    playersEntered
    prizesWon
    proceeds_donations
    proceeds_prizes
    proceeds_royalties
    ticket_luckyStars
    ticket_mainNumbers
    ticketsBought
    tiersResults {
      index
      prize
      prizePerWinner
      tier_luckyStar
      tier_mainNumber
      winningTickets
    }
    timestamp
    winningTickets
  }`
  }
}
`;
